import React, { FC, useState } from 'react';
import imgURL from '../../lib/imgURL';
import { TextInputProps } from './typings';
import './style.scss';
import { Tooltip } from 'antd';

const TextInput: FC<TextInputProps> = (props): JSX.Element => {
  const {
    label,
    type,
    value,
    placeholder,
    bgIcon,
    bgText,
    bgIconPosition = 'left',
    id,
    onBlur = () => { },
    handleChange = () => { },
    maxlength,
    className,
    error,
    errorMessage,
    isRequired,
    readonly,
    style = {},
    formGroupClassName,
    forgotPassword,
    sideNote = '',
    labelTooltip,
    isMasked = false,
    allowToggleVisibility = true,
    allowPaste = true,
    insideBtn = false,
    insideBtnTxt = '',
    customInsideBtnClass = '',
    insideBtnOnClick = () => { },
    verified = false,
    verifiedMessage= '',
  } = props;
  const [isFocus, setIsFocus] = useState<boolean>(false);
  const [isImageEye, setIsImageEye] = useState<boolean>(false);
  const bgIconStyle = bgIcon
  ? (bgIconPosition === 'left'
    ? {
        paddingLeft: '44px',
        background: `url(${bgIcon}) 16px center no-repeat`,
        backgroundPosition: '16px center',
      }
    : {
        paddingRight: '44px',
        background: `url(${bgIcon}) right 16px center no-repeat`,
        backgroundPosition: 'right 16px center',
      })
  : bgText ?
  ( bgIconPosition === 'left'
    ? {
        paddingLeft: '44px',
      }
    : {
        paddingRight: '44px',
      }): {};



  if(insideBtn) {
    style['width'] = '350px';
  } else {
    style['width'] = '100%';
  }

  if (verified && !bgIcon) {
    style['background'] = `url(${imgURL['green-tick']}) right 16px center no-repeat`;
    style['backgroundPosition'] = 'right 16px center';
    style['paddingRight'] = '44px';
    style['borderColor'] = 'green';
    
  } else {
    style['background'] = '';
    style['backgroundPosition'] = '';
    style['paddingRight'] = '';
    style['borderColor'] = '';
  }
  

  const maxLengthCheck = (object) => {
    if (maxlength && object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };
  const openEyeStyle = {
    background: `url(${imgURL['open-eye']}) 0 0 no-repeat`,
  };

  const closeEyeStyle = {
    background: `url(${imgURL['close-eye']}) 0 0 no-repeat`,
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    if (type === 'number' && Number(value) < 0) {
      return;
    }
    handleChange(event);
  };

  return (
    <div
      className={`form-group ${error ? 'error-field' : isFocus ? 'input-focus' : ''
        } ${formGroupClassName || ''}`}
    >
      {forgotPassword && forgotPassword}
      {label && (
        <label>
          {label}
          {isRequired && <em>*</em>}
          {labelTooltip && (
            <Tooltip
              placement="right"
              overlayInnerStyle={{ width: 330 }}
              color='#fff'
              title={props.labelTooltip}
            >
              <img src={imgURL["info-icon-light"]} alt="info-icon" style={{marginLeft:"5px", marginBottom:"3px"}}  />
            </Tooltip>
          )}
        </label>
      )}
      <input
        id={id}
        name={props.name}
        style={{ ...style, ...bgIconStyle }}
        type={(type !== 'password' && !isMasked) ? type : isImageEye ? 'text' : 'password'}
        value={value || ''}
        disabled={readonly}
        readOnly={verified}
        min={props?.min}
        max={props?.max}
        maxLength={maxlength}
        onInput={maxLengthCheck}
        placeholder={placeholder}
        className={`form-control ${className}`}
        onChange={handleInputChange}
        onFocus={() => setIsFocus(true)}
        onBlur={(e) => {
          setIsFocus(false);
          onBlur(e);
        }}
        onPaste={(e) => !allowPaste && e.preventDefault()}
      />
      {error && <div className='error'>{errorMessage}</div>}
      {(type === 'password' || isMasked) && allowToggleVisibility && (
        <span
          onClick={() => setIsImageEye(!isImageEye)}
          style={isImageEye ? openEyeStyle : closeEyeStyle}
          className='eye'
        ></span>
      )}

      {
        insideBtn ? <span className={`inside-btn ${customInsideBtnClass ? customInsideBtnClass : ''}`} onClick={insideBtnOnClick}>{insideBtnTxt}</span> : <></>
      }
      {bgText && (
        <span className={`bg-text ${bgIconPosition === 'left' ? 'bg-text-left' : 'bg-text-right'}`}>
          {bgText}
        </span>
      )}
      {verified && verifiedMessage && <div className='verified-message'>{verifiedMessage}</div>}

      
      {sideNote && <div className='sidenote'>{sideNote}</div>}

    </div>
  );
};

export default TextInput;
